"use client";

import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Block = {
  id: string;
  title: string;
  content: string;
  type: "normal" | "blockquote";
};
type ListItem = {
  id: number;
  blockId: string;
  text: string;
};
const blocks: Block[] = [{
  id: "overview",
  title: "Overview",
  content: "This project involved the complete renovation of a private residence in Palodia, Limassol, with a focus on enhancing both interior functionality and exterior living spaces. The objective was to modernise the property while improving efficiency, layout, and overall lifestyle quality.",
  type: "normal"
}, {
  id: "challenge",
  title: "The Challenge",
  content: "The existing layout required reconfiguration to better suit contemporary living, while the outdoor areas needed upgrades to support a more functional and comfortable environment. Additionally, technical improvements were necessary to enhance energy efficiency and system accessibility.",
  type: "normal"
}, {
  id: "approach",
  title: "Our Approach",
  content: "The renovation included a full interior transformation, with a redesigned layout to optimise space and flow throughout the home. Externally, the property was upgraded to improve usability and visual balance. The swimming pool plant room was relocated above ground for easier access and maintenance, while solar panels were installed to increase energy efficiency and long-term sustainability.",
  type: "normal"
}, {
  id: "result",
  title: "The Result",
  content: "The completed renovation delivered a modern, well-balanced residence that combines refined interior spaces with upgraded outdoor functionality. The improved layout, enhanced systems, and energy-efficient solutions significantly elevated both the comfort and value of the property.",
  type: "normal"
}];
const approachList: ListItem[] = [{
  id: 1,
  blockId: "approach",
  text: "Comprehensive system audit and bottleneck identification."
}, {
  id: 2,
  blockId: "approach",
  text: "Phased migration strategy with zero planned downtime."
}, {
  id: 3,
  blockId: "approach",
  text: "Implementation of robust security protocols."
}];
function ContentBlock({
  block,
  index
}: {
  block: Block;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-6">
        {block.title}
      </h2>

      {block.type === "blockquote" ? <blockquote className="border-l-4 border-border pl-6 py-2 my-8 italic font-sans text-lg md:text-xl text-foreground/90">
          <p className="leading-relaxed">{block.content}</p>
        </blockquote> : <p className="font-sans text-base md:text-lg text-foreground leading-relaxed mb-6">
          {block.content}
        </p>}

    </div>;
}
export default function MainContent() {
  return <section id="main-content" className="bg-background ![padding:40px_32px_96px_0px]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16 px-6 md:px-8">
        {blocks.map((block, i) => <ContentBlock key={block.id} block={block} index={i} />)}

        <div className="mt-2 flex justify-start">
          <Link to="https://ksluxury.cloudtech.com.cy/projects/" className="btn-primary">
            Back to Projects
          </Link>
        </div>
        
      </div>


    
    </section>;
}